//imports
import React, { useState, Component, useEffect } from 'react';
import { Button, Modal, Table, Row, Col, Container } from 'react-bootstrap';
//react-toastify
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';


//export class Contact extends Component
const Contact = () => {
    const displayName = Contact.name;
    //create useState
    const [contactus, setContactUs] = useState([])
    //lets make api call
    //useEffect(() => {
    //    fetch("https://localhost:44423/api/contactus/GetContactUs")
    //        .then(response => { return response.json() })
    //        .then(responseJson => {
    //            setContactUs(responseJson)
    //        })
    //}, []);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const { data: response } = await axios.get('https://localhost:44423/api/contactus/GetContactUs');
                setContactUs(response);
            } catch (error) {
                console.error(error.message);
            }
            setLoading(false);
        }

        fetchData();
    }, []);
    //useEffect(() => {
    //    debugger;
    //    Axios
    //        .get("https://localhost:44423/api/contactus/GetContactUs")
    //        .then(result => setContactUs(result.contactus));
    //    console.log(contactus);
    //    debugger;
    //})

    //this is for modal popup
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    //edit operation
    const handleEdit = (id) => {
        //if (window.confirm("Are you sure you want to edit?") === true) {
        //    alert(id);
        //}
        handleShow();
    }
    //delete operation
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete?") === true) {
            alert(id);
        }
    }
    //create
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [subject, setSubject] = useState('')
    const [message, setMessage] = useState('')

    //update
    const [editId, setEditId] = useState('')
    const [editName, setEditName] = useState('')
    const [editEmail, setEditEmail] = useState('')
    const [editSubject, setEditSubject] = useState('')
    const [editMessage, setEditMessage] = useState('')
    const handleUpdate = () => {
        //
    }

    //react tostify
    const notify = () => toast("Saved Successfully!");

    //render() {
        return (
            <div>

                <div className="container-fluid bg-primary py-5 bg-header">
                    <div className="row py-5">
                        <div className="col-12 pt-lg-5 mt-lg-5 text-center animated zoomIn">
                            <h3 className="text-capitalize text-white animated zoomIn">contact us</h3>
                            <a className="h5 text-capitalize text-white">home</a>
                            <i className="bi bi-chevron-right text-white px-2"></i>
                            <a className="h5 text-capitalize text-white">contact</a>
                        </div>
                    </div>
                </div>

                {/*contactus section starts here */}
                <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="container py-5">
                        <div class="row g-5">
                            <div class="col-lg-6">
                                <div class="section-title position-relative pb-3 mb-5">
                                    <h5 class="fw-bold text-primary text-uppercase">Contact Us</h5>
                                    <h1 class="text-uppercase mb-0">reach us</h1>
                                </div>
                                <p>
                                    <span class="bi bi-geo-alt me-3"></span>Nairobi Kenya<br />
                                    <span class="bi bi-geo-alt me-3"></span>Off Mombasa Road<br /><br />
                                    <span class="bi bi-phone me-3"></span>+254 792 188 931<br />
                                    <span class="bi bi-phone me-3"></span>+254 792 026 263<br />
                                    <span class="bi bi-envelope me-3"></span>
                                    <strong class="text-lowercase">info@jewstechs.com</strong><br />
                                </p>
                            </div>
                            <div class="col-lg-6">
                                <div class="bg-info rounded h-100 d-flex align-items-center p-4 wow zoomIn" data-wow-delay="0.9s">
                                    <form>
                                        <div class="row g-3">
                                            <div class="col-xl-12">
                                                <input type="text" class="form-control bg-light border-0" placeholder="Your Name" />
                                            </div>
                                            <div class="col-12">
                                                <input type="email" class="form-control bg-light border-0" placeholder="Your Email" />
                                            </div>
                                            <div class="col-12">
                                                <select class="form-select bg-light border-0">
                                                    <option selected>Select A Service</option>
                                                    <option value="1">CCTV</option>
                                                    <option value="2">Networking</option>
                                                    <option value="3">IT Infrastructure</option>
                                                </select>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control bg-light border-0" rows="3" placeholder="Message"></textarea>
                                            </div>
                                            <div class="col-12">
                                                <button class="btn my-btn btn-light btn-outline-secondary w-100 py-3" type="submit">Contact Us</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

        
            </div>

        );
    //}
}

export default Contact;